/**
 * Which RFCs are no one's own (S-32). The SAT's two generic keys identify nobody ("público en
 * general" and a resident abroad not enrolled); the portal's placeholder for a foreign national
 * living in Mexico stands in for the same thing until the person's RFC exists. The server decides
 * what a generic RFC blocks (`rfc_required`); this only tells the dashboard whether to remind.
 * The server refuses a MISSING RFC of a Mexican resident too (`rfc_required.lacks_real_rfc`), so the
 * reminder reads the same question: the person's own RFC is not on file.
 */
const SAT_GENERIC_RFCS: ReadonlySet<string> = new Set(['XAXX010101000', 'XEXX010101000']);

export function isGenericRfc(rfc: unknown, placeholder: string): boolean {
  if (typeof rfc !== 'string') return false;
  const key = rfc.trim().toUpperCase();
  return key !== '' && (SAT_GENERIC_RFCS.has(key) || key === placeholder.trim().toUpperCase());
}

/** The person's own RFC is not on file: none at all, or a generic one. Asked only of a Mexican
 *  resident, the one the server holds to it. */
export function lacksOwnRfc(rfc: unknown, placeholder: string): boolean {
  if (rfc === null || rfc === undefined) return true;
  if (typeof rfc !== 'string') return false;
  return rfc.trim() === '' || isGenericRfc(rfc, placeholder);
}

/** Shown next to the RFC field and, in the same words, by the server when the form is submitted
 *  (`rfc_required.TYPED_GENERIC_MESSAGE`): a resident of Mexico cannot give a SAT generic key as
 *  their RFC (RMF rule 2.7.1.23). The portal's own placeholder is not refused here: the form fills
 *  it in for a foreign national living in Mexico, and it is refused only at investing. */
export const TYPED_GENERIC_RFC_MESSAGE =
  "That RFC is a generic key for invoices to the public, not a person's own. Please give your own RFC.";

export function typedGenericRfcError(residence: unknown, rfc: unknown): string | null {
  if (residence !== 'MX' || typeof rfc !== 'string') return null;
  return SAT_GENERIC_RFCS.has(rfc.trim().toUpperCase()) ? TYPED_GENERIC_RFC_MESSAGE : null;
}
